module.exports = __webpack_public_path__ + "img/topic1.08f161aa.png";